/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDtoGeometry } from './CreateDiscreteNumericListDtoGeometry';
import {
    CreateDiscreteNumericListDtoGeometryFromJSON,
    CreateDiscreteNumericListDtoGeometryFromJSONTyped,
    CreateDiscreteNumericListDtoGeometryToJSON,
} from './CreateDiscreteNumericListDtoGeometry';
import type { BeamAnalysisWorkResultDtoCreatorUser } from './BeamAnalysisWorkResultDtoCreatorUser';
import {
    BeamAnalysisWorkResultDtoCreatorUserFromJSON,
    BeamAnalysisWorkResultDtoCreatorUserFromJSONTyped,
    BeamAnalysisWorkResultDtoCreatorUserToJSON,
} from './BeamAnalysisWorkResultDtoCreatorUser';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface NumericEvaluationResultDto
 */
export interface NumericEvaluationResultDto {
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    evaluationParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    name?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof NumericEvaluationResultDto
     */
    evaluationOutcome?: EvaluationState;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericEvaluationResultDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {BeamAnalysisWorkResultDtoCreatorUser}
     * @memberof NumericEvaluationResultDto
     */
    creatorUser?: BeamAnalysisWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamAnalysisWorkResultDtoCreatorUser}
     * @memberof NumericEvaluationResultDto
     */
    lastModifierUser?: BeamAnalysisWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    dataSetId?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof NumericEvaluationResultDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    actualValue?: number;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    deviationValue?: number;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    deviationUnit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericEvaluationResultDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {CreateDiscreteNumericListDtoGeometry}
     * @memberof NumericEvaluationResultDto
     */
    geometry?: CreateDiscreteNumericListDtoGeometry | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationResultDto
     */
    $type?: NumericEvaluationResultDtoTypeEnum;
}


/**
 * @export
 */
export const NumericEvaluationResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoNumericEvaluationResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.NumericEvaluationResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericEvaluationResultDtoTypeEnum = typeof NumericEvaluationResultDtoTypeEnum[keyof typeof NumericEvaluationResultDtoTypeEnum];



/**
 * Check if a given object implements the NumericEvaluationResultDto interface.
 */
export function instanceOfNumericEvaluationResultDto(value?: unknown): value is NumericEvaluationResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericEvaluationResultDtoTypeEnum)[0];
}

export function NumericEvaluationResultDtoFromJSON(json: any): NumericEvaluationResultDto {
    return NumericEvaluationResultDtoFromJSONTyped(json, false);
}

export function NumericEvaluationResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'evaluationParameterId': json['evaluationParameterId'] == null ? undefined : json['evaluationParameterId'],
        'name': json['name'] == null ? undefined : json['name'],
        'evaluationOutcome': json['evaluationOutcome'] == null ? undefined : EvaluationStateFromJSON(json['evaluationOutcome']),
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'creatorUser': json['creatorUser'] == null ? undefined : BeamAnalysisWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : BeamAnalysisWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'dataSetId': json['dataSetId'] == null ? undefined : json['dataSetId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'actualValue': json['actualValue'] == null ? undefined : json['actualValue'],
        'deviationValue': json['deviationValue'] == null ? undefined : json['deviationValue'],
        'deviationUnit': json['deviationUnit'] == null ? undefined : json['deviationUnit'],
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'geometry': json['geometry'] == null ? undefined : CreateDiscreteNumericListDtoGeometryFromJSON(json['geometry']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NumericEvaluationResultDtoToJSON(value?: Omit<NumericEvaluationResultDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'evaluationParameterId': value['evaluationParameterId'],
        'name': value['name'],
        'evaluationOutcome': EvaluationStateToJSON(value['evaluationOutcome']),
        'origin': EntityOriginToJSON(value['origin']),
        'iuid': value['iuid'],
        'creatorUser': BeamAnalysisWorkResultDtoCreatorUserToJSON(value['creatorUser']),
        'lastModifierUser': BeamAnalysisWorkResultDtoCreatorUserToJSON(value['lastModifierUser']),
        'dataSetId': value['dataSetId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'actualValue': value['actualValue'],
        'deviationValue': value['deviationValue'],
        'deviationUnit': value['deviationUnit'],
        'decimalPlaces': value['decimalPlaces'],
        'geometry': CreateDiscreteNumericListDtoGeometryToJSON(value['geometry']),
        '$type': value['$type'],
    });
}

